import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Insights as InsightIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/**
 * CTA card shown to SYSTEM_ADMIN on the dashboard.
 * Navigates to the statistics page where they can select a tenant.
 */
export const QuickStatsCTACard: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.012), 0px 2px 8px rgba(0, 0, 0, 0.012)',
      }}
    >
      <CardContent sx={{ py: 3 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: '50%',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              flexShrink: 0,
            }}
          >
            <InsightIcon sx={{ fontSize: 28, color: 'primary.main' }} />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
              {t('dashboard.quickStats.ctaTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('dashboard.quickStats.ctaDescription')}
            </Typography>
          </Box>

          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            onClick={() => navigate('/app/insight')}
            sx={{ textTransform: 'none', flexShrink: 0 }}
          >
            {t('dashboard.quickStats.viewInsight')}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
